module.exports = __webpack_public_path__ + "static/media/education-banner.7406c4f3.png";